import React from "react";
import PropTypes from "prop-types";

import "./button.component.scss";

function Button(props) {
    const { type, children, displayName, disabled, onClick, variant, buttonClass, ...optionalProps } = props;
    return (
        <button className={` text-white font-bold py-2 px-4 rounded-full ${buttonClass} ${disabled ? "disabled_div": "button"}`} onClick={onClick} disabled={disabled} {...optionalProps}>
       {displayName}
      </button>
    );
}
Button.defaultProps = {
    
    displayName: "Submit",
    buttonClass: ``,
    variant: "activebtn",
    disabled: false,
};
Button.propTypes = {
    type: PropTypes.string,
    displayName: PropTypes.string,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    variant: PropTypes.string,
    buttonClass: PropTypes.string,
};
export default Button;
